import React, { useState } from 'react';
import { faCheck, faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
    embedCode: string;
};

export default function WebsiteWidgetCode({ embedCode }: Props) {
    const [agreed, setAgreed] = useState<boolean>(false);
    const [copied, setCopied] = useState<boolean>(false);

    const copyEmbedCode = () => {
        setCopied(true);

        navigator.clipboard.writeText(
            `
                <div id="review-widget"></div>
                ${embedCode}
            `
        );

        setTimeout(() => setCopied(false), 3000);
    };

    return (
        <div className="ring-1 ring-brand_grey rounded-md sm:rounded-lg overflow-hidden">
            <h2 className="bg-brand_faint-blue text-md md:text-lg lg:text-xl p-3 sm:p-4 xl:px-6 font-bold flex items-center">
                <span className="px-3 py-2 rounded-xl bg-brand_primary text-white flex items-center justify-center text-xl font-bold me-2 min-w-20 whitespace-nowrap">Step 3</span> Generate your custom widget code to embed on your website
            </h2>
            <div className="border-t border-brand_grey-light p-3 sm:p-4 xl:p-6">
                <p>
                    To generate the widget code please agree to the <a href="https://www.nursinghomes.com/terms/" className="link" target="_blank">nursinghomes.com Terms & Conditions</a> regarding widget usage.
                </p>
                <div className="form-component form-checkbox mt-3 sm:mt-4">
                    <label>
                        <input
                            className="peer"
                            type="checkbox"
                            onChange={(event) => {
                                event.stopPropagation();
                                setAgreed(event.target.checked);
                            }}
                        />
                        <FontAwesomeIcon icon={faCheck} className="peer-checked:block"/>
                        I agree to the nursinghomes.com terms & conditions for widget usage
                    </label>
                </div>

                {agreed && (
                    <div className="mt-4 sm:mt-6">
                        <strong>
                            Please copy the below code and embed in your web page in the position you want the widget to show:
                        </strong>
                        <div className="mt-2">
                            <span className="msg msg-info">
                                If you are unsure how to embed this widget on your website please either send a link to this page to your web developers, or create your custom widget above and email your web developer the code.
                            </span>
                        </div>
                        <div role="button" onClick={() => copyEmbedCode()} className={`group relative cursor-pointer ${copied ? 'copied' : ''}`}>
                            <span className="hidden group-hover:flex absolute right-3 top-3 bg-brand_tertiary rounded-full items-center justify-center font-poppins px-2.5 pt-2 pb-1.5 text-[11.5px] font-medium text-white w-40">
                                <FontAwesomeIcon icon={faCopy} className="w-4 h-4 me-1 relative -top-px" />
                                <span className="group-[.copied]:hidden">Copy Code Snippet</span>
                                <span className="hidden group-[.copied]:block">Copied!</span>
                            </span>
                            <code className="mt-3 block bg-brand_faint-grey p-4 ring-1 ring-brand_grey text-violet-700 rounded-md break-all">
                                {'<div id="review-widget"></div>'}
                                <br/><br/>
                                {embedCode}
                            </code>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
